<template>
    <div
        class="modal fade"
        id="commentModal"
        tabindex="-1"
        aria-labelledby="commentModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <form @submit.prevent="addComment" class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="commentModalLabel">
                        {{ localise("good_host", "comment") }}
                    </h1>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <textarea
                        class="form-control py-3 rounded-c-3"
                        name="comment"
                        id="comment"
                        v-model="comment"
                        cols="30"
                        rows="3"
                        required
                    ></textarea>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-c-primary rounded-c-3 px-3 py-2 text-white shadow-sm"
                    >
                        {{ localise("good_host", "add_comment") }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import translations from "../../helpers/translations";

export default {
    props: ["id"],
    emits: ["addedComment"],
    data() {
        return {
            comment: "",
        };
    },
    methods: {
        addComment() {
            const data = {
                id: this.id,
                comment: this.comment,
            };

            this.$emit("addedComment", data);

            this.comment = "";
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
};
</script>
